import { init } from '@nosto/preact'

import serpComponent from './serp'
import categoryComponent from './category'
import autocompleteComponent from './autocomplete'
import historyComponent from './history'
import { defaultConfig } from './config'

import './styles/index.css'
import './styles/collectiontile.css'


// document.querySelectorAll('input#Search-Query')

// var categoryHeaderHtml;
// if(location.pathname.startsWith('/collections')){
//     categoryHeaderHtml = jQuery(".collection__header").html();
// }

init({
    ...window.nostoTemplatesConfig,
    serpComponent,
    historyComponent,
    autocompleteComponent,
    categoryComponent,
    inputCssSelector: 'input#Search-Query',
    formCssSelector: 'form#Search',
    contentCssSelector: 'main#MainContent',
    serpUrlMapping: {
        query: 'q',
    },
    // Uncomment to redirect to search page instead of rendering on the same page
    // serpPath: '/search',
    serpQuery: {
        products: {
            // fields: [
            //     'productId', 'url', 'name', 'imageUrl', 'thumbUrl', 'description', 'brand',
            //     'availability', 'price', 'priceText', 'listPrice', 'ratingValue', 'reviewCount', 'skus.id', 'skus.name'
            //     // 'customFields.key', 'customFields.value'
            // ],
            facets: ['*'],
            size: defaultConfig.serpSize,
            from: 0,
        },
    },
    autocompleteQuery: {
        products: {
            // fields: [
            //     'productId', 'url', 'name', 'imageUrl', 'thumbUrl', 'brand',
            //     'availability', 'price', 'priceText', 'listPrice', 'ratingValue', 'reviewCount'
            // ],
            size: defaultConfig.autocompleteProductsSize,
        },
        keywords: {
            fields: [
                'keyword', '_highlight.keyword'
            ],
            size: defaultConfig.autocompleteKeywordsSize,
        }
    },
    // Uncomment for Category Merchandising
    categoryCssSelector: 'div[data-collection-handle]',
    isCategoryPage: () => location.pathname.includes('/collections'),
    categoryQuery: () => {
        return {
            name: 'serp',
            products: {
                categoryId: document.querySelector('.nosto_category .id')?.textContent.trim(),
                size: defaultConfig.serpSize,
                from: 0,
            }
        }
    },
}).then(()=>{

    // closes the autocomplete when the "X" in the search header is clicked
    jQuery(".site-header__link.site-header__link--close-icon").on("click", function(){
        jQuery(".ns-autocomplete").fadeOut( "fast", function() {
            jQuery(".ns-autocomplete").remove();
      });
    })

    // if(location.pathname.startsWith('/collections')){
    //     jQuery("main").prepend(`<div class="collection__header">${categoryHeaderHtml}</div>`);
    // }
})
